import { ChangeDetectorRef, Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AutocompleteService } from '../../../core/data-services';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'rms-autocomplete-select',
    templateUrl: './autocomplete-select.component.html',
    styleUrls: ['./autocomplete-select.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => AutocompleteSelectComponent)
        }
    ],
    standalone: false
})
export class AutocompleteSelectComponent implements OnInit, ControlValueAccessor {

  @Input() item: any;
  @Output() itemChange = new EventEmitter<any>();

  @Input() items: Array<any>;
  @Output() itemsChange = new EventEmitter<Array<any>>();

  @Input() autocompleteName: string;
  @Input() entityType: new (x: any) => any;
  @Input() disabled = false;
  @Input() multiple = false;
  @Input() required = false;
  @Input() clearable = true;
  @Input() showAllTenants = false;
  @Input() placeholder: string;
  @Input() filterFn: (obj: any) => boolean;
  @Input() appendTo: string;
  /** Classes for the inner ng-select, which it also copies onto its dropdown when appended to the body. */
  @Input() selectClass: string;

  public typeahead = new Subject<string>();
  public searching = false;
  public itemList: Array<any> = [];
  public onChange: any;

  constructor(
    private autocompleteService: AutocompleteService,
    private cd: ChangeDetectorRef,
  ) { }

  ngOnInit() {
    this.initAutocomplete();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
  }

  writeValue(obj: any): void {
    if (this.multiple) {
      if (!obj || obj instanceof Array) {
        this.items = obj;
      } else {
        this.items = [...this.items, obj];
      }
    } else {
      this.item = obj;
    }
  }

  private initAutocomplete() {
    this.typeahead.pipe(
      distinctUntilChanged(),
      debounceTime(200),
      switchMap(term => {
        this.searching = true;
        return this.autocompleteService.autocompleteEntity(this.autocompleteName,
          { q: term, showAllTenants: this.showAllTenants });
      }),
    ).subscribe((value: any) => {
      this.searching = false;
      this.itemList = this.entityType ? value.records.map(v => new this.entityType(v)) : value.records;
      if (this.filterFn) {
        this.itemList = this.itemList.filter(this.filterFn);
      }
      this.cd.markForCheck();
    }, () => {
      this.searching = false;
      this.itemList = new Array<any>();
    });
  }

  onSelectionChange(value: any): void {
    if (this.multiple) {
      this.items = value;
      this.itemsChange.emit(value);
    } else {
      this.item = value;
      this.itemChange.emit(value);
    }
  }
}
